import { BaseComponent } from "utils/base-component"
import { MobileUnitSwitcher } from "./utils/mobile-unit-switcher"
import { MobileMenu } from "./utils/mobile-menu"
import { MobileDropdowns } from "./utils/mobile-dropdowns"
import "./page-header.scss"
import "./mobile-header.scss"
import "./components/favourites-dropdown.scss"
import "./components/forecast-channels.scss"
import "./components/user-nav.scss"
import "./components/mobile/menu-nav.scss"

require.context("./static", true, /\.svg|png$/)

export class PageHeader extends BaseComponent {
  static cssClass = "page-header"

  private mobileUnitSwitcher!: MobileUnitSwitcher
  private mobileMenu!: MobileMenu
  private mobileDropdowns!: MobileDropdowns

  init() {
    // call activeNav which highlights the current navigation item
    PageHeader.activeNav()
    // call components that need to be initialized
    this.mobileUnitSwitcher = new MobileUnitSwitcher(this.cssClass)
    this.mobileMenu = new MobileMenu(this.cssClass)
    this.mobileDropdowns = new MobileDropdowns(this.cssClass)

    // add click event listener to document to close menus when clicking outside the menus
    document.addEventListener("click", (e) => {
      // first check if this is the search button click
      if (this.mobileMenu.isSearchButtonClick(e)) {
        return
      }
      // then check if this is a button click to avoid race conditions
      if (
        e.target instanceof Node &&
        (this.mobileMenu.isMenuButtonClick(e.target) ||
          this.mobileDropdowns.isDropdownButtonClick(e.target))
      ) {
        return
      }

      // check if the click is inside any of the mobile menus or dropdowns
      const isMenuOrDropClick =
        e.target instanceof Node &&
        (this.mobileMenu.isMenuClick(e.target) || this.mobileDropdowns.isDropdownClick(e.target))

      // if the click is not inside any of the menus or dropdowns, close all mobile menus
      if (!isMenuOrDropClick) {
        this.mobileMenu.closeAllMobileMenus()
        this.mobileDropdowns.closeAllDropdowns()
      }
    })

    // add window resize listener to hide mobile menus when screen is resized to 768px or more
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 768) {
        // hide all mobile menus when viewport is 768px or larger
        this.mobileMenu.closeAllMobileMenus()
      }
    })
  }

  /**
   * Adds the 'active' class to navigation links that match the current page URL
   * Can be called on page load to highlight the current navigation item
   */
  private static activeNav(): void {
    // Get the current path from the window location
    const currentPath = window.location.pathname

    // Select all navigation links in the page header
    const navLinks = document.querySelectorAll(".page-header__bot-header a")

    // Loop through each link and check if it matches the current path
    navLinks.forEach((link) => {
      const href = link.getAttribute("href")

      // Skip links without href or with just "#" href
      if (!href || href === "#") return

      // Check for exact match
      if (href === currentPath) {
        link.classList.add("active")
      }
      // Check for sub-path match (for sections)
      else if (href !== "/" && currentPath.startsWith(href)) {
        link.classList.add("active")
      }
      // Special case for home page
      else if (href === "/" && currentPath === "/") {
        link.classList.add("active")
      }
    })
  }
}
